<button mat-icon-button class="overlay-close-button" mat-dialog-close #button>
  <fa-icon icon="times"></fa-icon>
</button>
